// --- Dark theme tokens (preserved - uncomment to restore dark landing) ---
// export const DARK_TOKENS = {
//   colors: {
//     black: '#000000',
//     obsidian: '#000000',
//     surface: '#0C0C0F',
//     surfaceElevated: '#141418',
//     border: 'rgba(255, 255, 255, 0.07)',
//     borderHover: 'rgba(159, 110, 218, 0.35)',
//     textPrimary: '#F2F2F4',
//     textSecondary: 'rgba(242, 242, 244, 0.65)',
//     textMuted: 'rgba(200, 200, 208, 0.45)',
//     highlight: '#E4E4E8',
//   },
//   glass: {
//     background: 'rgba(12, 12, 15, 0.72)',
//     backgroundStrong: 'rgba(20, 20, 24, 0.88)',
//   },
// };

export const TOKENS = {
  colors: {
    // Light page surfaces
    black: '#FFFFFF',
    obsidian: '#FFFFFF',
    surface: '#F8F9FB',
    surfaceElevated: '#FFFFFF',
    border: 'rgba(15, 23, 42, 0.1)',
    borderHover: 'rgba(123, 44, 191, 0.35)',
    textPrimary: '#111827',
    textSecondary: 'rgba(17, 24, 39, 0.68)',
    textMuted: 'rgba(17, 24, 39, 0.48)',
    highlight: '#1F2937',
    featureFadeTarget: '17, 24, 39',
    textOnImage: '#F8FAFC',
    textOnImageSecondary: 'rgba(248, 250, 252, 0.78)',

    lime: '#4CC66E',
    limeBright: '#38A858',
    limeNeon: '#2D9A4E',
    limeDark: '#2D8A47',

    purple: '#7B2CBF',
    violet: '#7B2CBF',
    purpleDeep: '#5B21A8',
    purpleSoft: '#9F6EDA',

    accent: '#4CC66E',
    accentDark: '#38A858',
    accentLight: '#5FD97F',
  },
  glow: {
    lime: 'rgba(76, 198, 110, 0.18)',
    purple: 'rgba(123, 44, 191, 0.12)',
    violet: 'rgba(123, 44, 191, 0.14)',
    accent: 'rgba(76, 198, 110, 0.15)',
  },
  glass: {
    blur: 'blur(12px)',
    background: 'rgba(255, 255, 255, 0.82)',
    backgroundStrong: 'rgba(255, 255, 255, 0.96)',
  },
  layout: {
    maxWidth: 1280,
    gutter: { xs: 16, sm: 24, lg: 32 },
  },
  spacing: (n) => `${n * 8}px`,
  section: {
    py: { xs: '32px', sm: '40px', md: '48px' },
    headingMb: { xs: 2.5, sm: 3, md: 3.5 },
    stackGap: { xs: 2, sm: 2.5, md: 3 },
    contentGap: { xs: 3, sm: 3.5, md: 4 },
    heroGap: { xs: 1.5, sm: 1.75, md: 2 },
  },
  radius: {
    sm: '12px',
    md: '18px',
    lg: '24px',
    xl: '32px',
  },
  transition: 'all 0.5s cubic-bezier(0.16, 1, 0.3, 1)',
  transitionFast: 'all 0.35s cubic-bezier(0.16, 1, 0.3, 1)',
  fonts: {
    display: '"Outfit", sans-serif',
    body: '"Outfit", sans-serif',
  },
  typography: {
    h1: 'clamp(2.625rem, 6vw, 4.75rem)',
    h2: 'clamp(2.125rem, 4.2vw, 3.375rem)',
    h3: 'clamp(1.375rem, 2.4vw, 1.625rem)',
    body: 'clamp(1.125rem, 1.25vw, 1.25rem)',
    bodySm: 'clamp(1rem, 1.1vw, 1.125rem)',
    label: '0.8125rem',
    caption: '0.875rem',
    nav: '1rem',
  },
  card: {
    bgcolor: 'rgba(255, 255, 255, 0.95)',
    border: 'rgba(76, 198, 110, 0.28)',
    shadow: '0 16px 48px rgba(15, 23, 42, 0.08), 0 1px 0 rgba(255, 255, 255, 0.9) inset',
  },
};

export const BRAND = {
  green: TOKENS.colors.lime,
  greenDark: TOKENS.colors.limeDark,
  greenLight: TOKENS.colors.limeBright,
  purple: TOKENS.colors.violet,
  black: TOKENS.colors.black,
  paper: TOKENS.colors.surface,
  muted: TOKENS.colors.textMuted,
  trial: TOKENS.colors.limeNeon,
};

export const INPUT_BG = '#FFFFFF';
export const INPUT_HEIGHT = 48;
export const INPUT_BORDER = 'rgba(15, 23, 42, 0.14)';
export const INPUT_BORDER_HOVER = 'rgba(123, 44, 191, 0.4)';
export const INPUT_FONT_SIZE = '1rem';

export const IMAGES = {
  heroAppOfTheDay: '/images/app-of-the-day-badge.png',
  heroSlides: [
    '/images/hero-slideshow/hero-slide-2.png',
    '/images/hero-slideshow/hero-slide-3.png',
    '/images/hero-slideshow/hero-slide-4.png',
    '/images/hero-slideshow/hero-slide-5.png',
  ],
  appShowcase: '/images/app-showcase-light.png',
  featureWorkout: '/images/feature-workout.png',
  featureCoach: '/images/feature-coach.png',
  featureMeals: '/images/feature-meals.png',
  featureOnboarding: '/images/feature-onboarding.png',
};
